import styled from "styled-components";
import { COLORS } from "../../assets/colors";
import carpoolBg from "../../assets/carpool_bg.png";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: url(${carpoolBg}) no-repeat center center fixed;
  background-size: cover;

  @media (max-width: 546px) {
    padding-bottom: 4rem;
  }

  .no-data {
    display: flex;
    padding: 1rem;
    justify-content: center;
    font-size: small;
    font-weight: 200 !important;
    color: #64748b;
    font-family: 'Inter', sans-serif;
  }

  .header {
    align: center;
    display: flex;
    justify-content: center;
    padding: 2rem;
    gap: 1rem;
    width: 100%;
    background: transparent;
    height: fit-content;
    flex-direction: column;
    align-items: center;

    h1 {
      font-weight: 700;
      color: #054752;
      margin: auto;
      font-size: 2rem;
      
      @media (max-width: 546px) {
        font-size: 1.5rem;
      }
    }

    .tabs {
      width: fit-content;
      height: auto;
      display: flex;
      gap: 0.5rem;
      background: rgba(255, 255, 255, 0.4);
      padding: 0.5rem;
      border-radius: 50px;
      backdrop-filter: blur(5px);
      flex-wrap: wrap;
      justify-content: center;

      div {
        cursor: pointer;
        width: fit-content;
        padding: 0.5rem 1.5rem;
        height: auto;
        background: transparent;
        text-align: center;
        justify-content: center;
        display: flex;
        align-items: center;
        color: #64748b;
        border-radius: 50px;
        margin: 0;
        font-weight: 600;
        transition: all 0.2s ease;

        :hover {
          color: #054752;
          background: rgba(255, 255, 255, 0.5);
        }

        @media (max-width: 546px) {
          padding: 0.5rem 1rem;
        }
      }

      .active {
        background: #054752;
        color: white;
        box-shadow: 0 4px 6px rgba(5, 71, 82, 0.2);
        border: none;
        
        :hover {
          background: #054752;
          color: white;
        }
      }
    }
  }
`;
export const CardButton = styled.button`
  display: block;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  background-color: ${(props) =>
    props.disabled
      ? COLORS.secondaryColor
      : props.buttonType === "accept"
      ? COLORS.primaryColor
      : "red"};
  color: #fff;
  font-size: 14px;
  cursor: ${(props) => (!props.disabled ? "pointer" : null)};
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
      !props.disabled && props.buttonType !== "reject" ? "#2d5e66" : null};
  }
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background-color: ${COLORS.primaryColor};
  color: white;
`;

export const TableHeadRow = styled.tr`
  text-align: left;
`;

export const TableHeadCell = styled.th`
  padding: 1rem;
`;

export const TableBody = styled.tbody`
  .isLoading {
    width: 100%;
    display: flex;
  }
`;

export const TableRow = styled.tr`
  .title {
    display: flex;
    align-items: center;
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: black;
      font-size: 1rem;
      img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }
  .route {
    a {
      text-decoration: none;
      color: ${COLORS.primaryColor};
      font-weight: bold;
    }
  }
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  svg {
    width: 15px;
    margin: -7px 2px;
  }
  .actionBtns {
    display: flex;
    justify-content: space-evenly;
    max-width: 132px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 546px) {
    .actionBtns {
      button {
        margin-bottom: 1rem;
      }
    }
  }
`;

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;
export const TableWrapper = styled.div`
  max-width: 900px;
  margin: 2rem auto;
  padding: 1rem;
  .pagination {
    margin: 2rem 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  @media (max-width: 546px) {
    margin: 0 auto;
  }
`;
